// removed by extract-text-webpack-plugin
module.exports = {"unit":"5px","summaryContainer":"manager-results-screen__summaryContainer____2B46O","statusContainer":"manager-results-screen__statusContainer____14YDO"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/screens/manager-results-screen/manager-results-screen.css
// module id = 708
// module chunks = 0